import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DeleteNope = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M4.73 12.213c2.087 1.62 5.127 1.473 7.041-.442 1.915-1.914 2.062-4.954.442-7.041L4.73 12.213Zm-.943-.943 7.483-7.483c-2.087-1.62-5.127-1.473-7.041.442-1.915 1.914-2.062 4.954-.442 7.041Zm-.501-7.984c2.593-2.593 6.835-2.593 9.428 0 2.593 2.593 2.593 6.835 0 9.428-2.593 2.593-6.835 2.593-9.428 0-2.593-2.593-2.593-6.835 0-9.428Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default DeleteNope;
